<template>
  <div v-if="displayInLife">
    <CarDeliveredCard
      v-if="displayDeliveredCard"
      :is-mobile="isMobile"
      :img="carDeliveredImg"
      :name="name"
      :rego="carDeliveredRego"
      class="q-mx-md"
    />
    <div class="q-pt-lg">
      <p
        class="text-h4 q-pb-sm q-pl-md text-weight-medium text-grey-10"
        v-if="!leasesLoading"
      >
        My Lease(s)
      </p>
      <LeaseStepper
        :lease-without-data-img="leaseWithoutDataImg"
        :lease-groups="leaseGroups"
        :loading="leasesLoading"
        :is-mobile="isMobile"
        @open:lease="$emit('open:lease', $event)"
        @open:budget="$emit('open:budget', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InLifeDashboard',
  props: {
    isMobile: Boolean,
    name: String,
    carDeliveredRego: String,
    carDeliveredImg: String,
    hasLeases: Boolean,
    leaseGroups: {
      type: Array,
      default: () => []
    },
    leasesLoading: Boolean,
    displayInLife: Boolean,
    displayDeliveredCard: Boolean,
    leaseWithoutDataImg: String
  },
  components: {
    CarDeliveredCard: () => import('../../molecule/car-delivered-card'),
    LeaseStepper: () => import('../../molecule/lease-stepper')
  }
};
</script>
